import { forwardRef } from "react";

import { Form } from "@shared/components/Form";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getBookAuthorsService } from "@modules/bookAuthors/services/queries/listBookAuthors/service";

export const BookAutorAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getBookAuthorsService} />
  );
});

BookAutorAutocomplete.displayName = "BookAutorAutocomplete";
